"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[692],{

/***/ 5692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages_login; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.6.2/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(3112);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(7458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(9754);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(2231);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(4682);
// EXTERNAL MODULE: ../../node_modules/.pnpm/isomorphic-fetch@2.2.1_encoding@0.1.13/node_modules/isomorphic-fetch/fetch-npm-browserify.js
var fetch_npm_browserify = __webpack_require__(8058);
var fetch_npm_browserify_default = /*#__PURE__*/__webpack_require__.n(fetch_npm_browserify);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(2983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/ts-pattern@5.0.1/node_modules/ts-pattern/dist/index.js
var dist = __webpack_require__(7538);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.6_@emotion+react@11.11.1_@emotion+server@11.11.0_@mui+material@5.13.5_react@18.2.0/node_modules/tss-react/esm/mui.js
var mui = __webpack_require__(1342);
// EXTERNAL MODULE: ../../modules/ui-base/src/contexts/snackbar.ts
var contexts_snackbar = __webpack_require__(8289);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(3089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@aws-sdk+client-cognito-identity-provider@3.391.0/node_modules/@aws-sdk/client-cognito-identity-provider/dist-es/models/models_0.js + 33 modules
var models_0 = __webpack_require__(7085);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(9758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(8417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.48.2/node_modules/@hookform/resolvers/zod/dist/zod.mjs + 2 modules
var zod = __webpack_require__(7940);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@martinjlowm+react-hook-form@7.45.4_react@18.2.0/node_modules/@martinjlowm/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(1555);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mdi+js@7.2.96/node_modules/@mdi/js/mdi.js
var mdi = __webpack_require__(5483);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mdi+react@1.6.1_react@18.2.0/node_modules/@mdi/react/Icon.js
var Icon = __webpack_require__(2242);
var Icon_default = /*#__PURE__*/__webpack_require__.n(Icon);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mobily+ts-belt@3.13.1/node_modules/@mobily/ts-belt/dist/esm/pipe.js
var pipe = __webpack_require__(676);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mobily+ts-belt@3.13.1/node_modules/@mobily/ts-belt/dist/esm/Dict/index.js
var Dict = __webpack_require__(5558);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@18.2.39_react@18.2.0/node_modules/@mui/icons-material/Check.js
var Check = __webpack_require__(6506);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@18.2.39_react@18.2.0/node_modules/@mui/icons-material/ShortText.js
var ShortText = __webpack_require__(2123);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@18.2.39_react@18.2.0/node_modules/@mui/icons-material/Visibility.js
var Visibility = __webpack_require__(616);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@18.2.39_react@18.2.0/node_modules/@mui/icons-material/VisibilityOff.js
var VisibilityOff = __webpack_require__(80);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(8824);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(1508);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/CardActions/CardActions.js + 1 modules
var CardActions = __webpack_require__(5723);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(4503);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/CardHeader/CardHeader.js + 1 modules
var CardHeader = __webpack_require__(7762);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(7848);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(1156);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/TextField/TextField.js + 44 modules
var TextField = __webpack_require__(6866);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/Tooltip/Tooltip.js + 58 modules
var Tooltip = __webpack_require__(7622);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(5863);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@23.7.6_react-dom@18.2.0_react@18.2.0/node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(7275);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@23.7.6_react-dom@18.2.0_react@18.2.0/node_modules/react-i18next/dist/es/Trans.js + 3 modules
var Trans = __webpack_require__(2886);
// EXTERNAL MODULE: ../../node_modules/.pnpm/zod@3.22.4/node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1850);
;// CONCATENATED MODULE: ../../modules/common/src/data-validator.ts
var isValidEmail = function(email) {
    var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email.toLowerCase());
};
var isValidPhoneNumber = function(phoneNumber) {
    //The number starts with +, contains numbers, is of length between 1  and 14
    var regex = /^\+[1-9]{1}[0-9]{1,14}$/;
    return regex.test(phoneNumber);
};
var isValidSensorTagName = function(tagName) {
    var regex = /^[a-zA-Z0-9\.\_]{1,}$/;
    return regex.test(tagName);
};
var containsPipeSymbol = function(text) {
    var regex = /[|]/;
    return regex.test(text);
};
var isValidFloatNumber = function(text) {
    var regex = /^-?\d+\.?\d*$/;
    return regex.test(text);
};

;// CONCATENATED MODULE: ./components/forms/schemas.ts


var challengeSchema = lib/* default.intersection */.ZP.intersection(lib/* default.object */.ZP.object({
    challengeName: lib/* default.string */.ZP.string(),
    challengeCode: lib/* default.string */.ZP.string().min(1)
}).required(), lib/* default.object */.ZP.object({
    session: lib/* default.string */.ZP.string().nullable()
}));
var forgotPasswordSchema = lib/* default.object */.ZP.object({
    email: lib/* default.string */.ZP.string()// .email(), TODO - Reintroduce when zod fixes support for apostrophe in email address prefix
    .refine(function(value) {
        return isValidEmail(value);
    })
}).required();
var setPasswordSchema = lib/* default.intersection */.ZP.intersection(challengeSchema, lib/* default.object */.ZP.object({
    email: lib/* default.string */.ZP.string()// .email(), TODO - Reintroduce when zod fixes support for apostrophe in email address prefix
    .refine(function(value) {
        return isValidEmail(value);
    }),
    password: lib/* default.string */.ZP.string(),
    confirmPassword: lib/* default.string */.ZP.string().min(1)
}).required().refine(function(param) {
    var password = param.password, confirmPassword = param.confirmPassword;
    return password === confirmPassword;
}, {
    message: "auth:requireEquality",
    path: [
        "password"
    ]
}));

;// CONCATENATED MODULE: ./components/forms/set-password.tsx































var i18nDefaultValues = {
    "auth:requireEquality": "The passwords must match",
    "auth:minimumLength": "Must have a minimum length of {{length}}",
    "auth:requireUppercase": "Must include an uppercase letter",
    "auth:requireLowercase": "Must include a lowercase letter",
    "auth:requireNumbers": "Must contain a number (0-9)",
    "auth:requireSymbols": "Must contain a special character (!@#$%^&* etc.)"
};
var resolver = (0,zod/* zodResolver */.F)(setPasswordSchema);
var validationI18nKeyMapping = {
    minimumLength: "auth:minimumLength",
    requireUppercase: "auth:requireUppercase",
    requireLowercase: "auth:requireLowercase",
    requireNumbers: "auth:requireNumbers",
    requireSymbols: "auth:requireSymbols",
    requireEquality: "auth:requireEquality"
};
var validationIconMapping = {
    minimumLength: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortText/* default */.Z, {});
    },
    requireUppercase: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
            size: 1,
            path: mdi/* mdiFormatLetterCaseUpper */.lQb
        });
    },
    requireLowercase: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
            size: 1,
            path: mdi/* mdiFormatLetterCaseLower */.OCV
        });
    },
    requireNumbers: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
            size: 1,
            path: mdi/* mdiNumeric */.tkb
        });
    },
    requireSymbols: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
            size: 1,
            path: mdi/* mdiSymbol */.u4p
        });
    },
    requireEquality: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
            size: 1,
            path: mdi/* mdiNotEqualVariant */.ha0
        });
    }
};
var staticPasswordPolicies = {
    requireUppercase: lib/* default.string */.ZP.string().regex(/(?=.*[A-Z])/),
    requireLowercase: lib/* default.string */.ZP.string().regex(/(?=.*[a-z])/),
    requireNumbers: lib/* default.string */.ZP.string().regex(/(?=.*\d)/),
    requireSymbols: lib/* default.string */.ZP.string().regex(/(.*[\^\$\*\.\[\]\{\}\(\)\?\-\+\"\!\@\#\%\&\\/\,\>\<\'\:\;\|\_\~\=\`].*)/)
};
var SetPassword = function(_param) {
    var onSubmit = _param.onSubmit, onCancel = _param.onCancel, defaultValues = _param.defaultValues, _passwordPolicy = _param.passwordPolicy, _ = _passwordPolicy.temporaryPasswordValidityDays, passwordPolicy = (0,_object_without_properties/* default */.Z)(_param.passwordPolicy, [
        "temporaryPasswordValidityDays"
    ]);
    var ref, ref1;
    var t = (0,useTranslation/* useTranslation */.$)("auth").t;
    var ref2 = (0,react.useState)(false), showPassword = ref2[0], setShowPassword = ref2[1];
    var theme = (0,useTheme/* default */.Z)();
    var policyValidations = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, staticPasswordPolicies), {
        minimumLength: lib/* default.string */.ZP.string().min(passwordPolicy.minimumLength)
    });
    var ref3 = (0,index_esm/* useForm */.cI)({
        mode: "onChange",
        defaultValues: defaultValues,
        resolver: resolver,
        criteriaMode: "all"
    }), register = ref3.register, handleSubmit = ref3.handleSubmit, getValues = ref3.getValues, setError = ref3.setError, _formState = ref3.formState, errors = _formState.errors, isValid = _formState.isValid;
    var email = getValues("email");
    var password = getValues("password");
    var challengeCode = getValues("challengeCode");
    var session = getValues("session");
    (0,react.useEffect)(function() {
        var ref, ref1;
        var types = (0,pipe/* pipe */.z)(policyValidations, Dict/* filterWithKey */.Zj(function(policyName, policy) {
            if (!passwordPolicy[policyName]) {
                return false;
            }
            return !policy.safeParse(password).success;
        }), Dict/* mapWithKey */.vp(function(policyName) {
            return i18nDefaultValues["auth:".concat(policyName)];
        }));
        if (Dict/* isEmpty */.xb(types)) {
            return;
        }
        var existingErrors = (ref = errors.password) === null || ref === void 0 ? void 0 : ref.types;
        if (existingErrors && Dict/* keys */.XP(types).every(function(key) {
            return key in existingErrors;
        })) {
            return;
        }
        setError("password", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errors.password), {
            types: (0,_object_spread/* default */.Z)({}, (ref1 = errors.password) === null || ref1 === void 0 ? void 0 : ref1.types, types)
        }));
    }, [
        setError,
        password,
        (ref = errors.password) === null || ref === void 0 ? void 0 : ref.types
    ]);
    var toggleShowPassword = (0,react.useCallback)(function() {
        setShowPassword(!showPassword);
    }, [
        showPassword
    ]);
    var submitForm = (0,react.useCallback)(function(event) {
        return handleSubmit(function(_param) {
            var _ = _param.confirmPassword, form = (0,_object_without_properties/* default */.Z)(_param, [
                "confirmPassword"
            ]);
            return onSubmit(form);
        })(event);
    }, []);
    var hasChallengeCode = !!challengeCode;
    var passwordErrors = (0,react.useMemo)(function() {
        var ref;
        return (errors === null || errors === void 0 ? void 0 : (ref = errors.password) === null || ref === void 0 ? void 0 : ref.types) || {};
    }, [
        errors === null || errors === void 0 ? void 0 : (ref1 = errors.password) === null || ref1 === void 0 ? void 0 : ref1.types
    ]);
    var passwordPolicyIcons = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(Dict/* keys */.XP(passwordPolicy)).concat([
            "requireEquality"
        ]).map(function(key) {
            var code = key === "requireEquality" ? "custom" : key;
            var Icon = code in passwordErrors ? validationIconMapping[key] : function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {});
            };
            var i18nKey = validationI18nKeyMapping[key];
            var defaultTranslation = i18nDefaultValues[i18nKey];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    arrow: true,
                    title: t(i18nKey, {
                        defaultValue: defaultTranslation,
                        length: passwordPolicy.minimumLength
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        sx: {
                            bgcolor: code in passwordErrors ? theme.palette.error.main : theme.palette.success.main
                        },
                        variant: "rounded",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
                    })
                })
            }, key);
        });
    }, [
        passwordErrors
    ]);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,dist/* match */.EQ)(session).with(null, function() {
        return [
            "verification code",
            t("auth:verificationCode", "Verification Code")
        ];
    }).otherwise(function() {
        return [
            "temporary password",
            t("auth:temporaryPassword", "Temporary Password")
        ];
    }), 2), challengeIdentifier = ref4[0], challengeLabel = ref4[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: submitForm,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                titleTypographyProps: {
                    align: "center"
                },
                subheaderTypographyProps: {
                    align: "center"
                },
                title: t("auth:setPassword", "Set Password"),
                subheader: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Trans/* Trans */.c, {
                    i18nKey: "auth:pleaseCheckYourEmailChallengeCode",
                    children: [
                        "Please check your e-mail, ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: {
                                email: email
                            }
                        }),
                        ", for a ",
                        {
                            challengeIdentifier: challengeIdentifier
                        },
                        "."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                            type: "hidden"
                        }, register("email"))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                            type: "hidden"
                        }, register("challengeName"))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                                fullWidth: true,
                                autoFocus: !hasChallengeCode,
                                error: "challengeCode" in errors,
                                autoComplete: "off",
                                required: true,
                                label: challengeLabel
                            }, register("challengeCode")))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                                autoFocus: hasChallengeCode,
                                fullWidth: true,
                                type: showPassword ? "text" : "password",
                                autoComplete: "new-password",
                                error: "password" in errors,
                                required: true,
                                label: t("auth:password", "Password"),
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                        position: "end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            tabIndex: -1,
                                            onClick: toggleShowPassword,
                                            children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {})
                                        })
                                    })
                                }
                            }, register("password", {
                                deps: [
                                    "confirmPassword"
                                ]
                            })))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                                fullWidth: true,
                                error: "confirmPassword" in errors,
                                type: showPassword ? "text" : "password",
                                autoComplete: "off",
                                required: true,
                                label: t("auth:confirmPassword", "Confirm Password"),
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                        position: "end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            tabIndex: -1,
                                            onClick: toggleShowPassword,
                                            children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {})
                                        })
                                    })
                                }
                            }, register("confirmPassword", {
                                deps: [
                                    "password"
                                ]
                            })))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            container: true,
                            item: true,
                            spacing: 2,
                            justifyContent: "space-around",
                            xs: 12,
                            children: passwordPolicyIcons
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                sx: {
                    p: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    justifyContent: "flex-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                fullWidth: true,
                                disabled: !isValid,
                                variant: "contained",
                                color: "primary",
                                type: "submit",
                                children: t("auth:setPassword", "Set Password")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                color: "primary",
                                onClick: onCancel,
                                children: t("common:returnToLogin", "Return to login")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var set_password = (SetPassword);

;// CONCATENATED MODULE: ./components/forms/challenge.tsx





// import MFAForm from './mfa';

var Challenge = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, models_0/* ChallengeNameType */.Wq), {
    RESET_PASSWORD: "RESET_PASSWORD"
});
var ChallengeForm = function(param) {
    var email = param.email, password = param.password, challengeCode = param.challengeCode, onSubmit = param.onSubmit, onCancel = param.onCancel, challenge = param.challenge;
    return (0,dist/* match */.EQ)(challenge.challengeName).with(Challenge.RESET_PASSWORD, Challenge.NEW_PASSWORD_REQUIRED, function(challengeName) {
        if (!challenge.passwordPolicy) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(set_password, {
            onSubmit: onSubmit,
            passwordPolicy: challenge.passwordPolicy,
            defaultValues: {
                email: email,
                password: password,
                challengeName: challengeName,
                challengeCode: challengeCode,
                session: challenge.session
            },
            onCancel: onCancel
        });
    }).with(Challenge.SELECT_MFA_TYPE, Challenge.SMS_MFA, Challenge.SOFTWARE_TOKEN_MFA, Challenge.ADMIN_NO_SRP_AUTH, Challenge.CUSTOM_CHALLENGE, Challenge.DEVICE_PASSWORD_VERIFIER, Challenge.DEVICE_SRP_AUTH, Challenge.MFA_SETUP, Challenge.PASSWORD_VERIFIER, function() {
        return null;
    }).exhaustive();
};
/* harmony default export */ var forms_challenge = (ChallengeForm);

;// CONCATENATED MODULE: ./components/forms/forgot-password.tsx













var forgot_password_resolver = (0,zod/* zodResolver */.F)(forgotPasswordSchema);
var ResetPassword = function(param) {
    var onSubmit = param.onSubmit, onCancel = param.onCancel, defaultValues = param.defaultValues;
    var t = (0,useTranslation/* useTranslation */.$)("auth").t;
    var ref = (0,index_esm/* useForm */.cI)({
        mode: "onChange",
        defaultValues: defaultValues,
        resolver: forgot_password_resolver
    }), register = ref.register, handleSubmit = ref.handleSubmit, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid;
    var resetPasswordTitle = t("auth:forgotPasswordTitle", "Forgot Password");
    var propagateForm = handleSubmit(onSubmit);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: propagateForm,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                titleTypographyProps: {
                    align: "center"
                },
                subheaderTypographyProps: {
                    align: "center"
                },
                title: resetPasswordTitle,
                subheader: t("auth:forgotPasswordGuidance", "Please enter your e-mail address to receive instructions for resetting your password or to get new verification code if you are yet to sign up and your current code has expired.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                        autoFocus: true,
                        fullWidth: true,
                        type: "email",
                        autoComplete: "username",
                        error: "email" in errors,
                        required: true,
                        label: t("auth:email", "E-mail")
                    }, register("email")))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                sx: {
                    p: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    justifyContent: "flex-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                fullWidth: true,
                                disabled: !isValid,
                                variant: "contained",
                                color: "primary",
                                type: "submit",
                                children: resetPasswordTitle
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                color: "primary",
                                onClick: onCancel,
                                children: t("common:returnToLogin", "Return to login")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var forgot_password = (ResetPassword);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(5771);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(9814);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/CardMedia/CardMedia.js + 1 modules
var CardMedia = __webpack_require__(9882);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@18.2.39_react-dom@18.2.0_react@18.2.0/node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(6224);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.6_@emotion+react@11.11.1_@emotion+server@11.11.0_@mui+material@5.13.5_react@18.2.0/node_modules/tss-react/esm/index.js + 14 modules
var esm = __webpack_require__(1683);
;// CONCATENATED MODULE: ./public/images/factbird-logo-black.svg
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


var SvgFactbirdLogoBlack = function SvgFactbirdLogoBlack(props, ref) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 801 132",
    ref: ref
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M627.013 49.483c5.176 0 9.373-4.187 9.373-9.352 0-5.166-4.196-9.353-9.373-9.353-5.176 0-9.374 4.187-9.374 9.353 0 5.165 4.197 9.352 9.374 9.352z",
    className: "factbird-logo-black_svg__eye",
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "m590.35 76.248-.002-2.203c-.033-19.065-.074-43.14 21.009-50.928 11.235-4.146 26.857-2.09 32.175 9.916 3.224 7.263 3.823 19.966-4.653 28.224-5.119 5.008-10.504 8.325-20.342 11.774-2.28.798-4.776 1.197-7.277 1.597-1.036.166-2.072.331-3.094.526V93.03c23.533 2.355 39.455 18.838 40.817 36.449h26.392c-4.886-20.728-16.354-35.786-35.831-45.57 17.538-8.618 29.278-24.533 28.857-44.736 3.673-3.017 10.471-8.682 12.99-11.314 1.728-1.824.831-4.776-1.961-5.406-6.002-1.326-13.12-3.17-17.617-4.367-4.192-6.263-10.351-11.413-18.381-14.239-19.644-6.931-49.758-6.169-65.38 15.655-10.935 15.223-11.135 37.245-11.135 59.333v50.644h23.4v-53.23Z",
    style: {
      display: "inline",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M0 129.944V2.089h85.656v20.596h-62.09V58.04h54.345v20.762H23.566v51.142zM76.382 129.944 120.556 2.089h30.281l44.207 127.855h-25.461l-9.107-27.296H110.95l-9.273 27.296zm41.283-48.058h35.931l-21.14-63.48h6.548zM255.439 132c-9.174 0-17.65-1.658-25.461-4.975-7.811-3.316-14.559-7.96-20.309-13.896-5.75-5.937-10.237-12.935-13.495-20.928-3.257-7.993-4.886-16.749-4.886-26.267 0-9.519 1.596-18.275 4.82-26.334 3.191-8.06 7.711-15.057 13.495-20.928 5.783-5.903 12.564-10.48 20.308-13.73C237.656 1.658 246.165 0 255.439 0c9.273 0 17.383 1.559 24.696 4.643 7.279 3.085 13.428 7.197 18.48 12.272 5.053 5.107 8.642 10.679 10.836 16.715l-20.973 9.95c-2.393-6.534-6.482-11.873-12.199-16.052-5.717-4.18-12.664-6.269-20.807-6.269-8.144 0-15.091 1.89-21.24 5.672-6.149 3.78-10.902 8.988-14.259 15.62-3.39 6.634-5.086 14.428-5.086 23.35 0 8.921 1.696 16.715 5.086 23.415 3.39 6.7 8.143 11.939 14.259 15.687 6.116 3.781 13.196 5.671 21.24 5.671 8.044 0 15.09-2.089 20.807-6.268 5.717-4.179 9.806-9.452 12.199-15.886l20.973 9.784c-2.194 6.069-5.783 11.641-10.836 16.715-5.052 5.108-11.201 9.187-18.48 12.271-7.279 3.085-15.523 4.644-24.696 4.644zM342.657 130.043V22.785h-33.206V2.189h89.445v20.596h-32.673v107.258ZM412.391 129.844V2.189h54.113c8.342 0 15.555 1.46 21.638 4.378 6.083 2.918 10.736 7.064 13.993 12.437 3.258 5.373 4.886 11.774 4.886 19.203 0 5.937-1.562 11.442-4.72 16.55-3.157 5.074-8.143 9.22-15.023 12.437V56.382c6.282 2.388 11.268 5.373 14.957 8.922 3.656 3.548 6.249 7.495 7.711 11.84 1.496 4.344 2.227 8.921 2.227 13.697 0 12.238-4.022 21.79-12.099 28.689-8.076 6.898-19.278 10.381-33.57 10.381h-54.113Zm23.533-78.138H467.7c4.82 0 8.642-1.393 11.501-4.213 2.858-2.785 4.287-6.434 4.287-10.878s-1.429-7.993-4.287-10.613c-2.859-2.62-6.681-3.947-11.501-3.947h-31.776zm0 57.575h32.973c6.082 0 10.902-1.691 14.525-5.041 3.623-3.383 5.418-7.86 5.418-13.465 0-5.605-1.795-10.116-5.418-13.532-3.623-3.416-8.443-5.14-14.525-5.14h-32.973zM525.436 129.844V2.189h23.532v127.655Z",
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/react.createElement("path", {
    d: "M692.127 129.778V2.255h41.847c13.495 0 25.228 2.72 35.233 8.126 10.005 5.406 17.75 12.935 23.234 22.52 5.484 9.584 8.243 20.596 8.243 33.033 0 12.437-2.759 23.481-8.243 33.1-5.484 9.651-13.229 17.179-23.234 22.585-10.005 5.406-21.771 8.126-35.233 8.126h-41.847zm23.5-20.53h18.879c8.675 0 16.221-1.791 22.569-5.406 6.349-3.615 11.301-8.623 14.825-15.057 3.556-6.434 5.318-14.062 5.318-22.851 0-8.79-1.762-16.384-5.318-22.852-3.557-6.434-8.476-11.442-14.825-14.957-6.348-3.549-13.86-5.307-22.569-5.307h-18.879z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeOpacity: 1
    }
  }));
};
var ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgFactbirdLogoBlack);
/* harmony default export */ var factbird_logo_black = (ForwardRef);
;// CONCATENATED MODULE: ./components/forms/login.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  60% {\n    d: path("       m 627.013,49.4834       c 5.1765,0  9.373,-4.1874   9.373,-9.3528         0,-5.1654 -1.5155,6.6472  -9.373,6.6472         -7.8575,0 -9.374,-11.8126 -9.374,-6.6472          0,5.1654 4.1975,9.3528   9.374,9.3528       z     ");\n  }\n'
    ], [
        '\n  60% {\n    d: path(" \\\n      m 627.013,49.4834 \\\n      c 5.1765,0  9.373,-4.1874   9.373,-9.3528 \\\n        0,-5.1654 -1.5155,6.6472  -9.373,6.6472 \\\n        -7.8575,0 -9.374,-11.8126 -9.374,-6.6472 \\\n         0,5.1654 4.1975,9.3528   9.374,9.3528 \\\n      z \\\n    ");\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}























var schema = lib/* default.object */.ZP.object({
    email: lib/* default.string */.ZP.string()// .email(), TODO - Reintroduce when zod fixes support for apostrophe in email address prefix
    .refine(function(value) {
        return isValidEmail(value);
    }),
    password: lib/* default.string */.ZP.string().min(1)
}).required();
var closedEye = (0,esm/* keyframes */.F4)(_templateObject());
var useStyles = (0,mui/* makeStyles */.ZL)()(function() {
    return {
        svg: {
            "& path:first-of-type": {
                animationDelay: "2s",
                animation: "".concat(closedEye, " 0.2s 1 ease")
            }
        }
    };
});
var login_resolver = (0,zod/* zodResolver */.F)(schema);
var LoginForm = function(param) {
    var onSubmit = param.onSubmit, onForgotPassword = param.onForgotPassword, defaultValues = param.defaultValues;
    var t = (0,useTranslation/* useTranslation */.$)("auth").t;
    var ref = (0,react.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var ref1 = (0,react.useState)(false), searchingUser = ref1[0], setSearchingUser = ref1[1];
    var ref2 = useStyles(), classes = ref2.classes, theme = ref2.theme;
    var logoRef = (0,react.useRef)(null);
    var intervalId = (0,react.useRef)(null);
    var ref3 = (0,index_esm/* useForm */.cI)({
        mode: "onChange",
        defaultValues: defaultValues,
        resolver: login_resolver
    }), register = ref3.register, handleSubmit = ref3.handleSubmit, _formState = ref3.// getValues,
    formState, errors = _formState.errors, isValid = _formState.isValid;
    // For use with SSO lookup to reveal that as an option
    // const validEmail = !('email' in errors) && getValues('email');
    // useEffect(() => {
    //   if (validEmail) {
    //     setSearchingUser(true);
    //     const searchTimeout = setTimeout(() => setSearchingUser(false), 10_000);
    //     return () => {
    //       setSearchingUser(false);
    //       clearTimeout(searchTimeout);
    //     };
    //   }
    // }, [validEmail]);
    (0,react.useEffect)(function() {
        intervalId.current = setInterval(function() {
            var svg = logoRef.current;
            if (svg) {
                if (svg.classList.contains(classes.svg)) {
                    svg.classList.remove(classes.svg);
                } else {
                    svg.classList.add(classes.svg);
                }
            }
        }, 5000 + Math.random() * 5000);
        return function() {
            if (intervalId.current) {
                clearInterval(intervalId.current);
            }
        };
    }, []);
    var toggleShowPassword = (0,react.useCallback)(function() {
        setShowPassword(!showPassword);
    }, [
        showPassword
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia/* default */.Z, {
                title: "Factbird",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    p: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(factbird_logo_black, {
                        ref: logoRef
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                titleTypographyProps: {
                    align: "center"
                },
                subheaderTypographyProps: {
                    align: "center"
                },
                title: t("auth:welcomeBack", "Welcome back"),
                subheader: t("auth:enterYourDetailsBelow", "Enter your details below.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                                autoFocus: true,
                                fullWidth: true,
                                error: "email" in errors,
                                required: true,
                                type: "email",
                                id: "email",
                                autoComplete: "username",
                                label: t("auth:email", "E-mail"),
                                sx: {
                                    paddingRight: 0
                                },
                                InputProps: {
                                    sx: {
                                        paddingRight: 0
                                    },
                                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                        sx: {
                                            position: "absolute",
                                            right: 0,
                                            margin: theme.spacing(1.5)
                                        },
                                        position: "end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            disabled: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                sx: {
                                                    opacity: searchingUser ? "1" : "0"
                                                },
                                                color: "inherit",
                                                disableShrink: true,
                                                size: "1em"
                                            })
                                        })
                                    })
                                }
                            }, register("email")))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                                fullWidth: true,
                                error: "password" in errors,
                                required: true,
                                type: showPassword ? "text" : "password",
                                id: "password",
                                autoComplete: "current-password",
                                label: t("auth:password", "Password"),
                                InputProps: {
                                    sx: {
                                        paddingRight: 0
                                    },
                                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                        sx: {
                                            position: "absolute",
                                            right: 0,
                                            margin: theme.spacing(1.5)
                                        },
                                        position: "end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            tabIndex: -1,
                                            onClick: toggleShowPassword,
                                            children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {})
                                        })
                                    })
                                }
                            }, register("password")))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                sx: {
                    p: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    justifyContent: "flex-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                fullWidth: true,
                                disabled: !isValid,
                                variant: "contained",
                                color: "primary",
                                type: "submit",
                                children: t("auth:signInTitle", "Sign In")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                color: "primary",
                                onClick: onForgotPassword,
                                children: t("auth:forgotPasswordQuestion", "Forgot password?")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var login = (LoginForm);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@mobily+ts-belt@3.13.1/node_modules/@mobily/ts-belt/dist/esm/Array/index.js
var esm_Array = __webpack_require__(5268);
;// CONCATENATED MODULE: ./dynamic-translation.tsx


// This is just a type trick to work around type error where i18nIsDynamicList
// does not exist (used by react-i18enext)
var DynamicTranslation = function(prop) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: prop.children
    });
};

;// CONCATENATED MODULE: ./components/splash-screens/loading.tsx














var loading_useStyles = (0,mui/* makeStyles */.ZL)()(function() {
    return {
        progress: {
            display: "block",
            margin: "0 auto"
        }
    };
});
var totalNumDots = 3;
var LoadingSplashScreen = function(param) {
    var challenge = param.challenge;
    var classes = loading_useStyles().classes;
    var t = (0,useTranslation/* useTranslation */.$)("auth").t;
    var ref = (0,react.useState)(0), dots = ref[0], setDots = ref[1];
    (0,react.useEffect)(function() {
        var intervalId = setInterval(function() {
            setDots((dots + 1) % (totalNumDots + 1));
        }, 600);
        return function() {
            clearTimeout(intervalId);
        };
    }, [
        dots
    ]);
    var preservedPosition = esm_Array/* repeat */.rx(totalNumDots - dots, ".").map(function(dot, i) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "span",
            sx: {
                opacity: 0
            },
            children: dot
        }, i);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, (0,_object_spread/* default */.Z)({
                titleTypographyProps: {
                    align: "center"
                },
                subheaderTypographyProps: {
                    align: "center"
                },
                subheader: t("auth:hangOnForAMoment", "Hang on for a moment.")
            }, (0,dist/* match */.EQ)(challenge).with(Challenge.NEW_PASSWORD_REQUIRED, function() {
                return {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Trans/* Trans */.c, {
                        i18nKey: "auth:renewingPassword",
                        children: [
                            "Renewing your password",
                            {
                                dots: ".".repeat(dots)
                            },
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicTranslation, {
                                i18nIsDynamicList: true,
                                children: preservedPosition
                            })
                        ]
                    })
                };
            }).with(Challenge.RESET_PASSWORD, function() {
                return {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Trans/* Trans */.c, {
                        i18nKey: "auth:resettingPassword",
                        children: [
                            "Resetting your password",
                            {
                                dots: ".".repeat(dots)
                            },
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicTranslation, {
                                i18nIsDynamicList: true,
                                children: preservedPosition
                            })
                        ]
                    })
                };
            }).with(Challenge.SMS_MFA, Challenge.SOFTWARE_TOKEN_MFA, function() {
                return {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Trans/* Trans */.c, {
                        i18nKey: "auth:submittingMFA",
                        children: [
                            "Submitting your multi-factor verification code",
                            {
                                dots: ".".repeat(dots)
                            },
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicTranslation, {
                                i18nIsDynamicList: true,
                                children: preservedPosition
                            })
                        ]
                    })
                };
            }).otherwise(function() {
                return {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Trans/* Trans */.c, {
                        i18nKey: "auth:signingIn",
                        children: [
                            "Signing you in",
                            {
                                dots: ".".repeat(dots)
                            },
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicTranslation, {
                                i18nIsDynamicList: true,
                                children: preservedPosition
                            })
                        ]
                    })
                };
            }))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            className: classes.progress,
                            size: 74,
                            color: "primary"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var splash_screens_loading = (LoadingSplashScreen);

;// CONCATENATED MODULE: ./components/splash-screens/successful.tsx

function successful_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      0% {\n        stroke-dashoffset: 1000;\n      }\n      100% {\n        stroke-dashoffset: 0;\n      }\n    "
    ]);
    successful_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      0% {\n        stroke-dashoffset: 1000;\n      }\n      100% {\n        stroke-dashoffset: 0;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var successful_useStyles = (0,mui/* makeStyles */.ZL)()(function() {
    return {
        checkmark: {
            width: "74px",
            display: "block",
            margin: "0 auto"
        },
        checkmarkCircle: {
            strokeDasharray: 1000,
            strokeDashoffset: 0,
            animation: "".concat((0,esm/* keyframes */.F4)(successful_templateObject()), " 0.9s ease-in-out")
        },
        checkmarkCheck: {
            strokeDasharray: 1000,
            strokeDashoffset: 1000,
            animation: "".concat((0,esm/* keyframes */.F4)(_templateObject1()), " 0.5s 0.35s ease-in-out forwards")
        }
    };
});
var redirectTimeout = 2500;
var successful_totalNumDots = 3;
var SuccessfulSplashScreen = function(param) {
    var navigate = param.navigate;
    var ref = successful_useStyles(), classes = ref.classes, theme = ref.theme;
    var t = (0,useTranslation/* useTranslation */.$)("auth").t;
    var ref1 = (0,react.useState)(0), dots = ref1[0], setDots = ref1[1];
    (0,react.useEffect)(function() {
        var intervalId = setInterval(function() {
            setDots(Math.min(successful_totalNumDots, dots + 1));
        }, Math.floor(redirectTimeout / successful_totalNumDots));
        return function() {
            clearTimeout(intervalId);
        };
    }, [
        dots
    ]);
    (0,react.useEffect)(function() {
        var redirectTimer = setTimeout(navigate, redirectTimeout);
        return function() {
            clearTimeout(redirectTimer);
        };
    }, []);
    var preservedPosition = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: esm_Array/* repeat */.rx(successful_totalNumDots - dots, ".").map(function(dot, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    opacity: 0
                },
                children: dot
            }, i);
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                titleTypographyProps: {
                    align: "center"
                },
                subheaderTypographyProps: {
                    align: "center"
                },
                title: t("auth:successfullySignedIn", "Successfully signed in!"),
                subheader: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Trans/* Trans */.c, {
                    i18nKey: "auth:navigating",
                    children: [
                        "Navigating to the application",
                        ".".repeat(dots),
                        preservedPosition
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: classes.checkmark,
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 130.2 130.2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    className: classes.checkmarkCircle,
                                    fill: "none",
                                    stroke: theme.palette.success.main,
                                    strokeWidth: "9",
                                    strokeMiterlimit: "10",
                                    cx: "65.1",
                                    cy: "65.1",
                                    r: "60.1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                                    className: classes.checkmarkCheck,
                                    fill: "none",
                                    stroke: theme.palette.success.main,
                                    strokeWidth: "9",
                                    strokeLinecap: "round",
                                    strokeMiterlimit: "10",
                                    points: "100.2,40.2 51.5,88.8 29.8,67.5 "
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var successful = (SuccessfulSplashScreen);

;// CONCATENATED MODULE: ./components/forms/auth.tsx











var PasswordPolicy = {
    minimumLength: dist.P.number,
    requireUppercase: dist.P.boolean,
    requireLowercase: dist.P.boolean,
    requireNumbers: dist.P.boolean,
    requireSymbols: dist.P.boolean,
    temporaryPasswordValidityDays: dist.P.number
};
var isChallengeFormSubmission = {
    challengeCode: dist.P.string,
    password: dist.P.string
};
var isLoginFormSubmission = {
    password: dist.P.string
};
var AuthForm = function(param) {
    var initialEmail = param.email, submitForm = param.onSubmit;
    // These states are only to preserve form state through navigation and if a
    // submission fails
    var ref = (0,react.useState)(initialEmail), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)(), password = ref1[0], setPassword = ref1[1];
    var ref2 = (0,react.useState)(), challengeCode = ref2[0], setChallengeCode = ref2[1];
    var ref3 = (0,react.useState)(null), challenge = ref3[0], setChallenge = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)(null), location = ref5[0], setLocation = ref5[1];
    var snackbar = (0,react.useContext)(contexts_snackbar/* SnackbarContext */.S);
    var ref6 = (0,react.useState)(false), hasForgottenPassword = ref6[0], setHasForgottenPassword = ref6[1];
    var forgotPassword = (0,react.useCallback)(function() {
        setHasForgottenPassword(true);
    }, []);
    var clearHasForgottenPassword = (0,react.useCallback)(function() {
        setHasForgottenPassword(false);
    }, []);
    var clearChallenge = (0,react.useCallback)(function() {
        setChallenge(null);
        clearHasForgottenPassword();
    }, []);
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(form) {
            var timeout;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        setEmail(form.email);
                        // State preservation when navigating forms after submission
                        (0,dist/* match */.EQ)(form).with(isChallengeFormSubmission, function(param) {
                            var challengeCode = param.challengeCode, password = param.password;
                            setChallengeCode(challengeCode);
                            setPassword(password);
                        }).with(isLoginFormSubmission, function(param) {
                            var password = param.password;
                            setChallengeCode(password);
                        });
                        timeout = new Promise(function(resolve) {
                            return setTimeout(resolve, 5000);
                        });
                        return [
                            4,
                            Promise.race([
                                submitForm(form),
                                timeout
                            ])
                        ];
                    case 1:
                        dist/* match.apply */.EQ.apply(void 0, [
                            _state.sent()
                        ]).with({
                            status: 200,
                            response: dist.P.select({
                                authCallback: dist.P.string,
                                authorizationCode: dist.P.string
                            })
                        }, function(param) {
                            var authCallback = param.authCallback, authorizationCode = param.authorizationCode;
                            return setLocation("".concat(authCallback, "?authorizationCode=").concat(authorizationCode));
                        }).with({
                            status: dist.P.number.between(400, 411),
                            response: {
                                message: dist.P.select(dist.P.string)
                            }
                        }, function(message) {
                            return snackbar.spawn(message, "error");
                        }).with({
                            status: 412,
                            response: dist.P.select({
                                challengeName: dist.P.string.and(dist.P.when(function(c) {
                                    return c in Challenge;
                                })),
                                passwordPolicy: PasswordPolicy,
                                session: dist.P.string.or(null)
                            })
                        }, function(challengeDetails) {
                            setChallenge(challengeDetails);
                        }).with({
                            status: 419,
                            response: dist.P.select({
                                message: dist.P.string,
                                redirect: dist.P.string
                            })
                        }, function(param) {
                            var message = param.message, redirect = param.redirect;
                            snackbar.spawn("".concat(message, " - Redirecting to ").concat(redirect, "..."), "error");
                            setTimeout(function() {
                                return window.location.assign(redirect);
                            }, 2500);
                        }).with({
                            status: 424
                        }, function() {
                            snackbar.spawn("MFA is not yet implemented...", "error");
                        }).with({
                            response: {
                                message: dist.P.select(dist.P.string)
                            }
                        }, function(message) {
                            return snackbar.spawn("An error ocurred: ".concat(message));
                        }).otherwise(function() {
                            snackbar.spawn("An error occured on sign-in", "error");
                        });
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(form) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var splashScreen = (0,dist/* match */.EQ)({
        loading: loading,
        location: location,
        challenge: challenge
    }).with({
        loading: true,
        location: null
    }, function(param) {
        var challenge = param.challenge;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(splash_screens_loading, {
            challenge: challenge && challenge.challengeName
        });
    }).with({
        loading: false,
        location: dist.P.string
    }, function(param) {
        var location = param.location;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(successful, {
            navigate: function() {
                return window.location.assign(location);
            }
        });
    }).otherwise(function() {
        return null;
    });
    if (splashScreen) {
        return splashScreen;
    }
    if (email && challenge) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_challenge, {
            email: email,
            password: password,
            challengeCode: challengeCode,
            onSubmit: onSubmit,
            onCancel: clearChallenge,
            challenge: challenge
        });
    }
    if (hasForgottenPassword) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(forgot_password, {
            onSubmit: onSubmit,
            onCancel: clearHasForgottenPassword
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(login, {
        defaultValues: {
            email: email,
            password: password
        },
        onForgotPassword: forgotPassword,
        onSubmit: onSubmit
    });
};
/* harmony default export */ var auth = (AuthForm);

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.22.5_react-dom@18.2.0_react@18.2.0/node_modules/next/router.js
var next_router = __webpack_require__(3883);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.22.5_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/compiled/querystring-es3/index.js
var querystring_es3 = __webpack_require__(5505);
;// CONCATENATED MODULE: ./hooks/use-url-query.ts




/**
 * Can't reliably extract QPs from Next's useRouter on initial client-side render.
 * [Issue](https://github.com/vercel/next.js/issues/10521)
 */ var useURLQuery = function() {
    var router = (0,next_router.useRouter)();
    var queryParams = (0,react.useMemo)(function() {
        var ref = (0,_sliced_to_array/* default */.Z)(router.asPath.split("?"), 2), pathStr = ref[1];
        return Object.entries((0,querystring_es3.parse)(pathStr)).reduce(function(normalizedQuery, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            var ref = (0,_sliced_to_array/* default */.Z)(Array.isArray(value) ? value : [
                value
            ], 1), primaryValue = ref[0];
            normalizedQuery[key] = primaryValue;
            return normalizedQuery;
        }, {});
    }, [
        router.asPath
    ]);
    return queryParams;
};

;// CONCATENATED MODULE: ./pages/login.tsx















var login_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        fillHeight: {
            height: "100%"
        },
        gridItem: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("xs"), {
            height: "100%",
            width: "100%"
        })
    };
});
var Login = function() {
    var ref = useURLQuery(), clientId = ref.clientId, authorizationCode = ref.authorizationCode, email = ref.email;
    var submitForm = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(_param) {
            var email, form, loginForm, method, encodedForm, response, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = _param.email, form = (0,_object_without_properties/* default */.Z)(_param, [
                            "email"
                        ]);
                        if (!clientId || !authorizationCode) {
                            return [
                                2
                            ];
                        }
                        loginForm = (0,_object_spread/* default */.Z)({
                            clientId: clientId,
                            authorizationCode: authorizationCode,
                            username: email
                        }, form);
                        method = (0,dist/* match */.EQ)(loginForm).with({
                            username: dist.P.string,
                            password: dist.P.string
                        }, function() {
                            return "POST";
                        }).otherwise(function() {
                            return "PUT";
                        });
                        encodedForm = Object.entries(loginForm).map(function(entries) {
                            return entries.map(encodeURIComponent).join("=");
                        }).join("&");
                        return [
                            4,
                            fetch_npm_browserify_default()("".concat(window.location.origin).concat(window.location.pathname), {
                                method: method,
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                },
                                body: encodedForm,
                                credentials: "same-origin"
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        _tmp = {
                            status: response.status
                        };
                        return [
                            4,
                            response.json().catch(function() {
                                return null;
                            })
                        ];
                    case 2:
                        return [
                            2,
                            (_tmp.response = _state.sent(), _tmp)
                        ];
                }
            });
        });
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var classes = login_useStyles().classes;
    if (!clientId || !authorizationCode) {
        // Should've been caught by Lambda@Edge
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "xs",
        className: classes.fillHeight,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            container: true,
            alignItems: "center",
            justifyContent: "center",
            className: classes.fillHeight,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                className: classes.gridItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(auth, {
                        email: email,
                        onSubmit: submitForm
                    })
                })
            })
        })
    });
};
var __N_SSG = true;
/* harmony default export */ var pages_login = (Login);


/***/ })

}]);